import { Injectable } from '@angular/core';
import * as Sentry from "@sentry/angular";

@Injectable({
  providedIn: 'root'
})
export class SentryService {

  constructor() { }

  public captureException(error: any, context?: any) {
    Sentry.captureException(error, {
      extra: context
    });
  }

  public captureMessage(message: string, level: 'fatal' | 'error' | 'warning' | 'info' | 'debug' = 'error', context?: any) {
    Sentry.captureMessage(message, {
      level: level,
      extra: context
    });
  }

  public addBreadcrumb(message: string, category?: string, level: 'fatal' | 'error' | 'warning' | 'info' | 'debug' = 'info', data?: any) {
    Sentry.addBreadcrumb({
      message: message,
      category: category,
      level: level,
      data: data
    });
  }
}
